import { TaxonomyType } from "data/types";
import React from "react";
import { Link } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";

type CardCategory6Props = {
  className?: string;
  taxonomy: TaxonomyType;
};

const CardCategory6 = ({ className = "", taxonomy }: CardCategory6Props) => {
  return (
    <Link
      to={taxonomy.href}
      className={`relative rounded-2xl h-full w-full aspect-w-4 aspect-h-1 sm:aspect-h-4 flex-shrink-0 hover:scale-105  ${className}`}
    >
      <div className="bg-gradient-to-br from-primary-700 to-primary-800 overflow-hidden brightness-75 contrast-75 rounded-2xl bg-opacity-50">
        <NcImage
          className="absolute overflow-hidden object-cover h-full w-full mix-blend-overlay bg-opacity-50"
          alt="category"
          src={taxonomy.thumbnail || ""}
        ></NcImage>
      </div>

      <div className="w-full h-full flex justify-center contrast-100 text-white items-center text-xl md:text-3xl lg:text-4xl font-bold text-center">
        <p>{taxonomy.name}</p>
      </div>
    </Link>
  );
};

export default CardCategory6;
